const t=Symbol.for("@inversifyjs/plugin/isPlugin");class n{[t]=!0;_container;_context;constructor(t,n){this._container=t,this._context=n}}export{n as Plugin,t as isPlugin};
//# sourceMappingURL=index.js.map
